export default __webpack_public_path__ + "static/media/nar88.796b689b.ico";